module.exports = __webpack_public_path__ + "static/media/ic-instant-book-yellow.a02f554b.svg";